import {SpriteButton} from '@fantasmagames/core/src/display/SpriteButton';
import {UpdateManager} from '@fantasmagames/core/src/update/UpdateManager';
import {Spine} from '@fantasmagames/core/src/spine/Spine';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {ButtonState} from '@fantasmagames/core/src/display/Button';

export class SpinButton extends SpriteButton {
	protected _updateManager: UpdateManager;
	protected _resources: ResourcesLoader;
	protected _currentAnimation: SpineAnimation;
	protected _additionalAnimation: SpineAnimation;

	protected _previousState: ButtonState;

	protected _isDisabled: boolean = false;

	constructor(callback: Function, updateManager: UpdateManager, resources: ResourcesLoader) {
		super(callback);
		this._updateManager = updateManager;
		this._resources = resources;

		this.interactive = true;
		this.buttonMode = true;

		this._previousState = ButtonState.UP;
	}

	public enable(): void {
		this._isDisabled = false;
		this.buttonMode = true;

		if (this._over) {
			this.setState(ButtonState.OVER);
		} else {
			this.setState(ButtonState.UP);
		}
	}

	public disable(): void {
		this.setState(ButtonState.DISABLED);

		this._isDisabled = true;
		this.buttonMode = false;
	}

	protected setState(value: ButtonState): void {
		if (this._state !== value && this._updateManager && !this._isDisabled) {
			this._previousState = this._state;
			this._state = value;

			switch (value) {
				case ButtonState.DISABLED: {
					this.stopCurrentAnimation();
					this.stopAdditionalAnimation();
					this.startAdditionalAnimation('RELEASE', false);
					this.startButtonAnimation('SPIN', true);
					break;
				}
				case ButtonState.DOWN: {
					this.stopCurrentAnimation();
					this.stopAdditionalAnimation();
					this.startButtonAnimation('PRESSED', false, true);
					break;
				}
				case ButtonState.UP: {
					if (this._previousState === ButtonState.OVER) {
						this.stopAdditionalAnimation();
					} else {
						this.stopCurrentAnimation();
						this.stopAdditionalAnimation();
						this.startButtonAnimation('IDLE', true);
					}

					break;
				}
				case ButtonState.OVER: {
					if (this._previousState === ButtonState.UP) {
						this.stopAdditionalAnimation();
						this.startAdditionalAnimation('HOVER', true);
					} else {
						this.stopCurrentAnimation();
						this.stopAdditionalAnimation();
						this.startButtonAnimation('IDLE', true);
						this.startAdditionalAnimation('HOVER', true);
					}

					break;
				}

				default:
					break;
			}
		}
	}

	protected onClick(): void {
		this.setState(ButtonState.OVER);

		if (this._callback) {
			if (!this._isDisabled) {
				this._callback();
			}
		} else {
			// console.warn('There is no a callback.');
		}
	}

	protected startButtonAnimation(animationName: string, loop: boolean, dontDestroyOnComplete?: boolean): void {
		this.stopCurrentAnimation();
		this._currentAnimation = new SpineAnimation(
			new Spine(this._resources.getSpine('SPIN_BUTTON_NOGLOW.json')),
			animationName,
			loop,
			dontDestroyOnComplete,
		);
		this._updateManager.add(this._currentAnimation);
		this.addChild(this._currentAnimation.container);
		this._currentAnimation.start();
	}

	protected startAdditionalAnimation(animationName: string, loop: boolean, dontDestroyOnComplete?: boolean): void {
		this.stopAdditionalAnimation();
		this._additionalAnimation = new SpineAnimation(
			new Spine(this._resources.getSpine('SPIN_BUTTON_GLOW.json')),
			animationName,
			loop,
			dontDestroyOnComplete,
		);
		this._updateManager.add(this._additionalAnimation);
		this.addChild(this._additionalAnimation.container);
		this._additionalAnimation.start();
	}

	protected stopCurrentAnimation(): void {
		if (this._currentAnimation) {
			this.removeChild(this._currentAnimation.container);
			this._currentAnimation.forceDestroy();
			this._currentAnimation = null;
		}
	}

	protected stopAdditionalAnimation(): void {
		if (this._additionalAnimation) {
			this.removeChild(this._additionalAnimation.container);
			this._additionalAnimation.forceDestroy();
			this._additionalAnimation = null;
		}
	}

	protected updateFrame(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButton.ts